import React from 'react'
import ReactMarkdown from 'utils/markdown'
import SectionType from 'models/types/ts/sectionType'
import { Modal, useModal } from 'layouts/modal'
import { HeadingXSmall } from 'layouts/typography'
import { Icon } from 'layouts'
// import LinkArrow from '../../../pages/www/components/shared/link-arrow'
import style from './Guidelines.module.scss'

interface Props {
    section: SectionType
}

const Guidelines = ({ section }: Props): JSX.Element => {
    const { name, body, buttonText } = section
    const { isOpen, toggleModal } = useModal()

    return (
        <div className={style.guidelines}>
            <button
                className={style.highlight}
                onClick={toggleModal}
                type="submit"
            >
                {buttonText}
                <Icon name="long-arrow-right" />
            </button>
            {/* <LinkArrow>
                {buttonText}
            </LinkArrow> */}
            <Modal isOpen={isOpen} hide={toggleModal}>
                <div className={style.content}>
                    <HeadingXSmall>{name}</HeadingXSmall>
                    <ReactMarkdown source={body} />
                </div>
            </Modal>
        </div>
    )
}

export default Guidelines
